@if (showEmptyState()) {
    <div
        class="a-fx a-fx-between-center left-section empty"
        nz-dropdown
        nzTrigger="click"
        [nzDropdownMenu]="menu"
        nzPlacement="bottomRight"
    >
        <span class="line-type">
            @if (symbol()) {
                <adspt-icon class="marker" [name]="marker()" />
            }
        </span>
        <span class="metric-name">{{ placeholder() || ('common.add-metric' | translate) }}</span>
        <div class="a-fx a-fx-end-center icons">
            <span [class.a-visible-hidden]="spotlight()">
                <adspt-icon class="arrow" name="caret-down" />
            </span>
        </div>
    </div>
} @else {
    <div
        [class.disabled]="disable()"
        class="a-fx a-fx-start-center left-section"
        nz-dropdown
        nzTrigger="click"
        [nzClickHide]="false"
        nzPlacement="bottomRight"
        [nzDropdownMenu]="menu"
        [nzVisible]="isVisible()"
        (nzVisibleChange)="isVisible.set($event)"
    >
        <span class="line-type" [style.background]="color()" [style.color]="color()">
            @if (symbol()) {
                <adspt-icon class="marker" [name]="marker()" />
            }
        </span>
        <span class="metric-name"><ng-content></ng-content></span>
        <div class="a-fx a-fx-between-center icons">
            @if (showSpotlight()) {
                <span (adsptDelayedHover)="changeValue($event)" (click)="$event.stopPropagation()">
                    <adspt-icon
                        class="eye no-select"
                        [name]="spotlight() ? 'eye-filled' : 'eye'"
                        [class.active]="spotlight()"
                        [style.color]="spotlight() ? color() : 'inherit'"
                    ></adspt-icon
                ></span>
            }
            <span class="dd-icon" [class.a-visible-hidden]="spotlight()">
                <adspt-icon class="arrow" name="caret-down"></adspt-icon
            ></span>
            @if (showClose()) {
                <span (click)="$event.stopPropagation(); changeMetric(null)" [class.a-visible-hidden]="spotlight()">
                    <adspt-icon class="close" name="cross"></adspt-icon
                ></span>
            }
        </div>
    </div>
}

<nz-dropdown-menu #menu="nzDropdownMenu">
    <div class="options-menu">
        @for (item of options(); track item) {
            @if (disableOption() !== item) {
                <li
                    class="ant-dropdown-menu-item"
                    (click)="isVisible.set(false); changeMetric(item)"
                    [adsptHeap]="heapName()"
                    [heapData]="{ metric: item }"
                >
                    <span class="subtitle">{{ translations()[item]?.title }}</span>
                </li>
            }
        }
    </div>
</nz-dropdown-menu>
